<template>
  <div class="content">
    <div class="footer-overlay"></div>
    <div class="content-info">
      <div class="info-slot left">
        <v-icon>mdi-movie-search-outline</v-icon>
        <span>{{ videosFoundFeedback }}</span>
      </div>

      <div class="info-slot right">
        <v-btn text icon title="atualizar">
          <v-icon>refresh</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-search">
      <v-text-field
        v-model="localVideoQuery"
        filled
        rounded
        hide-details
        single-line
        clearable
        clear-icon="close"
        label="Pesquisar vídeos no globoplay..."
        append-icon="search"
        color="graydark"
        background-color="graylighter"
        @click:append="handleVideoSearch"
        @keydown.enter="handleVideoSearch"
        @click:clear="resetVideoSearch"
      ></v-text-field>
    </div>

    <div
      v-show="videos && videos.length > 0"
      class="video-list"
      ref="videoList"
      v-infinite-scroll="searchVideos"
      infinite-scroll-disabled="isLoading"
      infinite-scroll-distance="0"
      infinite-scroll-immediate-check="false"
    >
      <GloboplayVideoPlayer
        v-for="(video, index) in videos"
        :key="index"
        :video="video"
        :videoID="index"
      ></GloboplayVideoPlayer>
    </div>
    <div v-show="!videos || videos.length <= 0">
      <Error
        :textTitle="'Tão <span>vazio</span> por aqui...'"
        :textDescription="
          'Não encontramos nenhum vídeo relacionado ao conteúdo da retranca atual.'
        "
        :imageTitle="'bored'"
        class="empty-search inside"
      />
    </div>
    <LoadingOverlay :enabled="isLoading" z-index="999" />
  </div>
</template>
<script>
import Error from '@/components/shared/Error.vue';
import GloboplayVideoPlayer from '@/components/stories/storyDetailSidebar/GloboplayVideoPlayer';
import infiniteScroll from 'vue-infinite-scroll';
import LoadingOverlay from '../../shared/LoadingOverlay.vue';

export default {
  directives: { infiniteScroll },
  components: {
    GloboplayVideoPlayer,
    Error,
    LoadingOverlay,
  },
  props: {
    selectedStory: Object,
    videos: Array,
    isLoading: Boolean,
    videoQuery: String,
  },
  computed: {
    videosFoundFeedback() {
      const videosLength = this.videos ? this.videos.length : 0;
      if (videosLength === 0) return 'não encontramos vídeos relacionados';
      if (videosLength === 1)
        return `encontramos ${videosLength} vídeo relacionado`;
      return `encontramos ${videosLength} vídeos relacionados`;
    },
    localVideoQuery: {
      get() {
        return this.videoQuery;
      },
      set(value) {
        this.$emit('setVideoQuery', value);
      },
    },
  },
  methods: {
    handleVideoSearch() {
      this.$refs.videoList.scrollTop = 0;
      this.$emit('handleVideoQuerySearch');
    },
    resetVideoSearch() {
      this.$refs.videoList.scrollTop = 0;
      this.$emit('clearVideoSearch');
    },
    searchVideos() {
      this.$emit('searchVideos');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/content-panel.scss';
</style>
